import logo from '../../assets/logo.png'
import css from './EnlaceCaducado.module.css'

const EnlaceCaducado = ()=> (  
  <div className={css.main}>
    <img className={css.imagen} src={logo} alt="logo" />
    <div className={css.content}>
      <h1 className={css.title}>Enlace caducado</h1>
      <p className={css.text}>
        Pero no te preocupes, estamos aquí para ayudarte. Si necesitas más información, contáctanos en{' '}
        <a className={css.link} href="mailto:hola@mundoestudiante.com">
          hola@mundoestudiante.com
        </a>
      </p>
    </div>
  </div>
)

export default EnlaceCaducado